import { setGlobalOfflineMode } from 'boot/network';

export default {
  networkSetStatus(isOnline) {
    this.networkOnline = isOnline;
  }, // networkSetStatus()

  offlineModeSetStatus(isOfflineMode) {
    this.offlineMode = isOfflineMode;
    setGlobalOfflineMode(isOfflineMode);
    localStorage.setItem('offlineModeStatus', isOfflineMode);
  }, // offlineModeSetStatus()

  setSwitchingModesStatus() {
    this.switchingModes = true;
  }, // setSwitchingModesStatus()

  setForceOffline(bool) {
    this.forceOffline = bool;
  }, // setForceOffline()
};
